/**
 * Core Tasks API Client (Epic 2 — Kerntakencatalogus, Story 2.2)
 *
 * Explicitly named `lib/coreTasksApi.ts` in ARCHITECTURE-SPINE.md's
 * Consistency Conventions ("API-clients in lib/coreTasksApi.ts"). Separate
 * from `settingsApi.ts` — kerntaken is its own, growing domain (Epic 3/4
 * build on it), see Story 2.1 Dev Notes for the same rationale applied to
 * the shared types/schemas split.
 */

import { apiRequest } from './api';
import type { CoreTaskDTO, CreateCoreTaskRequest, UpdateCoreTaskRequest } from '@functieloonhuis/shared';

interface DataResponse<T> {
  data: T;
}

export const coreTasksApi = {
  list: async (includeArchived = false): Promise<CoreTaskDTO[]> => {
    const query = includeArchived ? '?includeArchived=true' : '';
    const res = await apiRequest<DataResponse<CoreTaskDTO[]>>(`/core-tasks${query}`);
    return res.data;
  },

  get: async (id: number): Promise<CoreTaskDTO> => {
    const res = await apiRequest<DataResponse<CoreTaskDTO>>(`/core-tasks/${id}`);
    return res.data;
  },

  create: async (data: CreateCoreTaskRequest): Promise<CoreTaskDTO> => {
    const res = await apiRequest<DataResponse<CoreTaskDTO>>('/core-tasks', {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return res.data;
  },

  update: async (id: number, data: UpdateCoreTaskRequest): Promise<CoreTaskDTO> => {
    const res = await apiRequest<DataResponse<CoreTaskDTO>>(`/core-tasks/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return res.data;
  },

  archive: async (id: number): Promise<CoreTaskDTO> => {
    const res = await apiRequest<DataResponse<CoreTaskDTO>>(`/core-tasks/${id}/archive`, {
      method: 'POST',
    });
    return res.data;
  },

  reactivate: async (id: number): Promise<CoreTaskDTO> => {
    const res = await apiRequest<DataResponse<CoreTaskDTO>>(`/core-tasks/${id}/reactivate`, {
      method: 'POST',
    });
    return res.data;
  },
};
